import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filter',
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], args: any[]): any {
    if (items) {
      const campos: string[] = args[0];
      return items.filter(item => campos.find(campo => ('' + item[campo]).toLowerCase().indexOf(args[1].toLowerCase()) !== -1));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/filter/filter.ts